<template>
    <div class="row" v-if="isValid('CanDraftExpense') || isValid('CanViewExpense')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" v-if="isDayAlreadyStart">
            <div class="row mb-4" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                <div class="col-sm-6 col-md-6 col-lg-6">
                    <h5 class="page_title">{{ $t('DailyExpense.DailyExpense') }}</h5>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link :to="'/StartScreen'"><a href="javascript:void(0)"> {{ $t('DailyExpense.Home') }}</a></router-link></li>

                            <li class="breadcrumb-item active" aria-current="page">{{$t('DailyExpense.Expense') }}</li>
                        </ol>
                    </nav>
                </div>
                <div class=" col-sm-6 col-md-6 col-lg-6">
                    <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                        <a href="javascript:void(0)" class="btn btn-primary " v-on:click="AddPurchaseOrder" v-if="isValid('CanAddExpense') || isValid('CanDraftExpense') "><i class="fa fa-plus"></i> {{ $t('DailyExpense.AddNew') }}</a>
                        <router-link :to="'/StartScreen'"><a href="javascript:void(0)" class="btn btn-outline-danger "> {{ $t('DailyExpense.Close') }}</a></router-link>
                    </div>

                </div>
            </div>
            <div class="card ">
                <div class="card-header " v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                    <div class="row mb-3 ml-1 ">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div class="form-group">
                                <label>{{ $t('DailyExpense.Search') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" name="search" id="search" :placeholder="$t('DailyExpense.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>{{ $t('DailyExpense.FromDate') }}</label>
                                <datepicker v-model="fromDate" />
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>{{ $t('DailyExpense.ToDate') }}</label>
                                <datepicker v-model="toDate" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class=" mb-1">
                                <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'arabicLanguage'">
                                    <ul class="nav nav-tabs" data-tabs="tabs">
                                        <li v-if="isValid('CanDraftExpense') " class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Draft'}" v-on:click="makeActive('Draft')" id="v-pills-home-er" data-toggle="pill" href="#v-pills-er" role="tab" aria-controls="v-pills-er" aria-selected="true">{{ $t('DailyExpense.Draft') }}</a></li>
                                        <li v-if="isValid('CanViewExpense')" class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Approved'}" v-on:click="makeActive('Approved')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">{{ $t('DailyExpense.Post') }}</a></li>
                                        <!--<li v-if="isValid('Can View  Expense as Reject')" class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Rejected'}" v-on:click="makeActive('Rejected')" id="v-pills-amazed-tab" data-toggle="pill" href="#v-pills-amazed" role="tab" aria-controls="v-pills-amazed" aria-selected="false">{{ $t('DailyExpense.Rejected') }}</a></li>-->

                                    </ul>
                                </div>
                            </div>
                            <div class="tab-content mt-3" id="nav-tabContent">
                                <div v-if="active == 'Draft'" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
                                    <!--<div class="row" v-if="selected.length > 0">
                                        <div class="col-md-3 ">
                                            <div class="dropdown">
                                                <button class="dropdown-toggle btn btn-primary  btn-block" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    {{ $t('DailyExpense.BulkAction') }}
                                                </button>
                                                <div class="dropdown-menu " style="text-align:center !important" aria-labelledby="dropdownMenuButton">

                                                    <a class="dropdown-item" v-if="isValid('Can Bulk Expense Approved')" href="javascript:void(0)" v-on:click="UpdateApprovalStatus('Approved')"> {{ $t('PurchaseOrder.Approve') }}</a>
                                                    <a class="dropdown-item" v-if="isValid('Can Bulk Expense Rejected')" href="javascript:void(0)" v-on:click="UpdateApprovalStatus('Rejected')">{{ $t('PurchaseOrder.Reject') }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>-->

                                    <div class="table-responsive">
                                        <table class="table  table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
                                                    <!--<th>
                                                        <label class="form-checkbox">
                                                            <input type="checkbox" v-model="selectAll" @click="select">
                                                            <i class="form-icon"></i>
                                                        </label>
                                                    </th>-->
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.VoucherNo') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CounterName') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CreatedBy') }}
                                                    </th>

                                                    <th>
                                                        {{ $t('DailyExpense.Date') }}
                                                    </th>
                                                    <th v-if="IsExpenseAccount">
                                                        {{ $t('DailyExpense.PaymentMode') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.ReferenceNo')}}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.Description') }}
                                                    </th>
                                                    <th v-if="IsExpenseAccount">
                                                        {{ $t('DailyExpense.TotalVAT') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.TotalAmount') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.Action') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(details,index) in dailyExpenseList" v-bind:key="details.id">
                                                    <!--<td>
                                                        <label class="form-checkbox">
                                                            <input type="checkbox" v-model="selected" :value="details.id">
                                                            <i class="form-icon"></i>
                                                        </label>

                                                    </td>-->
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>
                                                    <td v-if="isValid('CanEditExpense')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="DailyExpenseDetail(details.id)">{{details.voucherNo}}</a>
                                                        </strong>

                                                    </td>
                                                    <td v-else>{{details.voucherNo}}</td>
                                                    <td>
                                                        {{details.counterName}}
                                                    </td>
                                                    <td>
                                                        {{details.createdUser}}
                                                    </td>

                                                    <td>
                                                        {{details.date}}
                                                    </td>
                                                    <td v-if="IsExpenseAccount">
                                                        {{details.paymentMode=='Default'?'':details.paymentMode }}
                                                    </td>
                                                    <td>
                                                        {{details.referenceNo}}
                                                    </td>
                                                    <td>
                                                        {{details.description}}
                                                    </td>
                                                    <td v-if="IsExpenseAccount">
                                                        {{parseFloat(details.totalVat).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td>
                                                        {{currency}}  {{parseFloat(details.totalAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>

                                                    <td>
                                                        <a href="javascript:void(0)" title="A4" class="btn  btn-icon btn-primary btn-sm " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'mr-1' : 'ml-1'" v-on:click="PrintInvoice(details.id)" v-if="isValid('CanPrintExpense') "><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="POS" class="btn  btn-icon btn-primary btn-sm" v-on:click="PrintPosInvoice(details.id)" v-if="isValid('CanPrintExpense') "><i class=" fa fa-print"></i></a>
                                                        <button class="btn btn-icon btn-sm  btn-primary " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'ml-1' : 'mr-1'" v-on:click="ViewDailyExpense(details.id)" v-if="isValid('CanViewDetailExpense') "><i class="fas fa-eye"></i></button>
                                                        <a href="javascript:void(0)" class="btn btn-danger btn-sm btn-icon " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'ml-1' : 'mr-1'" v-on:click="DeleteDailyExpense(details.id)" v-if="isValid('CanDeleteExpense') "><i class=" fa fa-trash"></i></a>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left" :key="randerList">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" v-if="($i18n.locale == 'en' ||isLeftToRight())" :key="randerList">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" v-else :key="randerList">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="active == 'Approved'">



                                    <div class="table-responsive">
                                        <table class="table table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.VoucherNo') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CounterName') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CreatedBy') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.ApprovedBy') }}
                                                    </th>

                                                    <th>
                                                        {{ $t('DailyExpense.Date') }}
                                                    </th>
                                                    <th v-if="IsExpenseAccount">
                                                        {{ $t('DailyExpense.PaymentMode') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.ReferenceNo')}}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.Description') }}
                                                    </th>

                                                    <th v-if="IsExpenseAccount">
                                                        {{ $t('DailyExpense.TotalVAT') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.TotalAmount') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.Action') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(details,index) in dailyExpenseList" v-bind:key="details.id">
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>
                                                    <!--<td v-if="isValid('Can Edit Expense')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="DailyExpenseDetail(details.id)">{{details.voucherNo}}</a>
                                                        </strong>

                                                    </td>-->
                                                    <td>{{details.voucherNo}}</td>
                                                    <td>
                                                        {{details.counterName}}
                                                    </td>
                                                    <td>
                                                        {{details.createdUser}}
                                                    </td>
                                                    <td>
                                                        {{details.userName}}
                                                    </td>
                                                    <td>
                                                        {{details.date}}
                                                    </td>
                                                    <td v-if="IsExpenseAccount">
                                                        {{details.paymentMode=='Default'?'':details.paymentMode }}
                                                    </td>
                                                    <td>
                                                        {{details.referenceNo}}
                                                    </td>

                                                    <td>
                                                        {{details.description}}
                                                    </td>
                                                    <td v-if="IsExpenseAccount">
                                                        {{parseFloat(details.totalVat).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td>
                                                        {{currency}}  {{parseFloat(details.totalAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>

                                                    <td>
                                                        <a href="javascript:void(0)" title="A4" class="btn  btn-icon btn-primary btn-sm" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'mr-1' : 'ml-1'" v-on:click="PrintInvoice(details.id)" v-if="isValid('CanPrintExpense') "><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="POS" class="btn  btn-icon btn-primary btn-sm" v-on:click="PrintPosInvoice(details.id)" v-if="isValid('CanPrintExpense') "><i class=" fa fa-print"></i></a>
                                                        <button class="btn btn-icon btn-sm  btn-primary " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'ml-1' : 'mr-1'" v-on:click="ViewDailyExpense(details.id)" v-if="isValid('CanViewDetailExpense') "><i class="fas fa-eye"></i></button>

                                                    </td>
                                                    <!--<td v-if="!details.isActive">
                                                        <a href="javascript:void(0)" class="btn btn-danger btn-sm btn-icon " v-on:click="DeleteDailyExpense(details.id)"><i class=" fa fa-trash"></i></a>
                                                    </td>-->
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" v-if="($i18n.locale == 'en' ||isLeftToRight())" :key="randerList">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" v-else :key="randerList">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>
                                </div>
                                <!--<div v-if="active == 'Rejected'">



                                    <div class="table-responsive">
                                        <table class="table table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.VoucherNo') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CounterName') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.CreatedBy') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('RejectedBy') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.Date') }}
                                                    </th>

                                                    <th>
                                                        {{ $t('Reason') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('DailyExpense.TotalAmount') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Action') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(details,index) in dailyExpenseList" v-bind:key="details.id">
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>


                                                    <td>{{details.voucherNo}}</td>
                                                    <td>
                                                        {{details.counterName}}
                                                    </td>
                                                    <td>
                                                        {{details.createdUser}}
                                                    </td>
                                                    <td>
                                                        {{details.userName}}
                                                    </td>
                                                    <td>
                                                        {{details.date}}
                                                    </td>

                                                    <td>
                                                        {{details.reason}}
                                                    </td>
                                                    <td>
                                                        {{currency}}  {{parseFloat(details.totalAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td>
                                                        <a href="javascript:void(0)" title="A4" class="btn  btn-icon btn-primary btn-sm" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'mr-1' : 'ml-1'" v-on:click="PrintInvoice(details.id)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="POS" class="btn  btn-icon btn-primary btn-sm" v-on:click="PrintPosInvoice(details.id)"><i class=" fa fa-print"></i></a>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getData()" v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getData()" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>
                                </div>-->

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!--<div class="col-lg-6 col-sm-6 ml-auto mr-auto" v-else-if="isDayAlreadyStart && showListPermision=='false'">
            <div class="card p-3 text-center ">
                <h4 class="">{{ $t('YouHaveNotPermission') }}</h4>
                <router-link :to="'/daystart'"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('Dashboard.DayStart') }}</a></router-link>
            </div>
        </div>-->
        <div class="col-lg-6 col-sm-6 ml-auto mr-auto" v-else>
            <div class="card p-3 text-center " v-if="bankDetail">
                <h4 class="">{{ $t('DailyExpense.FirstStartInvoice') }}</h4>
                <router-link :to="'/WholeSaleDay'"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('DailyExpense.DayStart') }}</a></router-link>
            </div>
            <div class="card p-3 text-center " v-else>
                <h4 class="">{{ $t('DailyExpense.FirstStartInvoice') }}</h4>
                <router-link :to="'/dayStart'"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('DailyExpense.DayStart') }}</a></router-link>
            </div>
        </div>
        <actionmodal :approvalStatusVm="updateApprovalStatus"
                     :show="show"
                     v-if="show"
                     @close="close" />
        <dailyExpenseA4 :printDetails="printDetails" :headerFooter="headerFooter" :formName="formName" v-if="printDetails.length != 0" v-bind:key="printRender"></dailyExpenseA4>
        <dailyExpenseThreeInch :printDetails="printDetailsPos" :formName="formName" :headerFooter="headerFooter" v-if="printDetailsPos.length != 0" v-bind:key="printPosRender"></dailyExpenseThreeInch>
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>

<script>
    import clickMixin from '@/Mixins/clickMixin'
    import moment from "moment";
    export default {
        mixins: [clickMixin],
        props: ['formName'],
        data: function () {
            return {
                bankDetail: false,
                fromDate: '',
                toDate: '',
                active: 'Draft',
                search: '',
                searchQuery: '',
                dailyExpenseList: [],
                purchasePostList: [],
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                currency: '',
                printRender: 0,
                randerList: 0,
                printPosRender: 0,
                selected: [],
                selectAll: false,
                updateApprovalStatus: {
                    action: '',
                    selected: [],
                    total: 0,
                    accountSelect: 'ForExpense'
                },
                show: false,
                IsExpenseAccount: false,
                CompanyID: '',
                UserID: '',
                employeeId: '',
                isDayAlreadyStart: false,
                IsProduction: false,
                userName: '',
                counter: 0,
                printDetails: '',
                printDetailsPos: '',
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
            }
        },
        watch: {
            search: function (val) {
                this.getData(val, this.currentPage, this.active, '', '');
            },
            fromDate: function (fromDate) {
                
                this.counter++;
                if (this.counter != 1) {
                    localStorage.setItem('fromDate', fromDate);

                    this.getData(this.search, this.currentPage, this.active, fromDate, this.toDate);
                }
            },
            toDate: function (toDate) {
                
                this.counter++;
                if (this.counter != 2) {
                    localStorage.setItem('toDate', toDate);

                    this.getData(this.search, this.currentPage, this.active, this.fromDate, toDate);
                }
            },
            formName: function () {
                
                if (this.$route.query.data == 'AddDailyExpense') {
                    this.$emit('input', 'AddDailyExpense');

                }
                else {
                    this.$emit('input', this.$route.name);
                    localStorage.removeItem("fromDate");
                    localStorage.removeItem("toDate");

                }
                
               
                if (this.formName == 'dailyexpense') {

                    this.IsExpenseAccount = false;
                }
                else {
                    this.IsExpenseAccount = localStorage.getItem('IsExpenseAccount') == 'true' ? true : false;
                }

                    this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate);
                
            },
        },
        methods: {

            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                            root.printRender++;
                        }
                        
                    })
            },

            GetInvoicePrintSetting: function () {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;

                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },

            GetHeaderDetail: function () {
                

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.GetInvoicePrintSetting();
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            PrintInvoice: function (value) {
                this.GetHeaderDetail();
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetails = [];
                root.printDetailsPos = [];
                root.$https.get("/Company/EditDailyExpenseDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetails = response.data;
                            root.printRender++;
                        }
                    });
            },
            PrintPosInvoice: function (value) {
                
                this.GetHeaderDetail1();
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetails = [];
                root.printDetailsPos = [];
                root.$https.get("/Company/EditDailyExpenseDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetailsPos = response.data;
                        }
                    });
            },
            ViewDailyExpense: function (id) {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/EditDailyExpenseDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            
                            root.$router.push({
                                path: '/DailyExpenseView',
                                query: {
                                    data: response.data,
                                    formName: root.formName
                                }
                            })
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },

            DailyExpenseDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/EditDailyExpenseDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.$router.push({
                            path: '/adddailyexpense',
                            query: {
                                data: response.data,
                                formName: root.formName
                            }
                        })
                    }
                });

            },
            GetHeaderDetail1: function () {
                

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.printPosRender++;

                        }
                    });
            },

            select: function () {

                this.selected = [];
                if (!this.selectAll) {
                    for (let i in this.dailyExpenseList) {
                        this.selected.push(this.dailyExpenseList[i]);
                    }
                }
            },
            getPage: function () {
                
                this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate);
            },
            close: function (x) {

                if (x == true) {
                    this.show = false;
                }
                else {
                    this.show = false;
                    this.makeActive(x);
                }

            },
            makeActive: function (item) {


                this.active = item;
                this.selectAll = false;
                this.selected = [];

                this.getData(this.search, 1, item, this.fromDate, this.toDate);
            },
            UpdateApprovalStatus: function (action) {


                this.updateApprovalStatus.action = action;
                var total = 0;
                for (let item in this.selected) {
                    total = total + this.selected[item].totalAmount;
                }
                this.updateApprovalStatus.total = total;
                this.updateApprovalStatus.selected = this.selected;
                this.show = !this.show;

            },
            getData: function (search, currentPage, status, fromDate, toDate) {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                localStorage.setItem('currentPage', this.currentPage);
                localStorage.setItem('active', this.active);
                this.$https.get('/Company/DailyExpenseList?status=' + status + '&searchTerm=' + search + '&pageNumber=' + currentPage + '&fromDate=' + fromDate + '&toDate=' + toDate, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {

                        if (response.data != null) {
                            root.$store.dispatch('GetDailyExpenseList', response.data.results);
                            root.dailyExpenseList = response.data.results;
                            root.pageCount = response.data.pageCount;
                            root.rowCount = response.data.rowCount;
                            root.currentPage = currentPage;
                            root.randerList++;
                        }
                        else {
                            root.$swal({
                                title: "Error!",
                                text: "Error",
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                buttonsStyling: false
                            });
                        }
                    });
            },
            DeleteDailyExpense: function (id) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/DailyExpenseDelete?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.$swal.fire({
                            icon: 'warning',
                            title: 'Deleted Successfully',
                            showConfirmButton: false,
                            timer: 800,
                            timerProgressBar: true,
                        });
                        if (root.isValid('CanDraftExpense')) {
                            root.makeActive("Draft");
                        }
                        else if (root.isValid('CanViewExpense')) {
                            root.makeActive("Approved");
                        }
                    }
                });
            },
            AddPurchaseOrder: function () {

                
                this.$router.push({
                    path: '/adddailyexpense',
                    query: {
                        formName: this.formName
                    }

                });


             
            }
        },
        created: function () {
            
            if (this.$route.query.data == 'AddDailyExpense') {
                this.$emit('input', 'AddDailyExpense' + this.formName);

            }
            else {
                this.$emit('input', this.$route.name + this.formName);
                localStorage.removeItem("fromDate");
                localStorage.removeItem("toDate");


            }
           
            if (localStorage.getItem('fromDate') != null && localStorage.getItem('fromDate') != '' && localStorage.getItem('fromDate') != undefined) {
                this.fromDate = localStorage.getItem('fromDate');

            }
            else {
                this.fromDate = moment().add(-7, 'days').format("DD MMM YYYY");

            }
            if (localStorage.getItem('toDate') != null && localStorage.getItem('toDate') != '' && localStorage.getItem('toDate') != undefined) {
                this.toDate = localStorage.getItem('toDate');

            }
            else {
                this.toDate = moment().format("DD MMM YYYY");
            }
        },
        mounted: function () {
            
            if (this.formName == 'dailyexpense') {
               
                this.IsExpenseAccount = false;
            }
            else {
                this.IsExpenseAccount = localStorage.getItem('IsExpenseAccount') == 'true' ? true : false;
            }
            this.bankDetail = localStorage.getItem('BankDetail') == 'true' ? true : false;
            


            var IsDayStart = localStorage.getItem('DayStart');
            var IsDayStartOn = localStorage.getItem('IsDayStart');
            var AllowAll = localStorage.getItem('AllowAll');
            if (IsDayStart != 'true') {
                this.isDayAlreadyStart = true;
                if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                    this.currentPage = parseInt(localStorage.getItem('currentPage'));
                    this.active = (localStorage.getItem('active'));
                    this.getPage();

                }
                else {
                    if (this.isValid('CanDraftExpense') ) {
                        this.makeActive("Draft");
                    }
                    else if (this.isValid('CanViewExpense') ) {
                        this.makeActive("Approved");
                    }
                    

                }
                this.currency = localStorage.getItem('currency');
            }
            else {
                if (AllowAll == 'false') {
                    this.CompanyID = localStorage.getItem('CompanyID');
                    this.UserID = localStorage.getItem('UserID');
                    this.employeeId = localStorage.getItem('EmployeeId');
                    if (IsDayStartOn == 'true') {
                        this.isDayAlreadyStart = true;
                        if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                            this.currentPage = parseInt(localStorage.getItem('currentPage'));
                            this.active = (localStorage.getItem('active'));
                            this.getPage();

                        }
                        else {
                            if (this.isValid('CanDraftExpense')) {
                                this.makeActive("Draft");
                            }
                            else if (this.isValid('CanViewExpense')) {
                                this.makeActive("Approved");
                            }

                        }
                    }
                    this.currency = localStorage.getItem('currency');

                }
                else {
                    this.isDayAlreadyStart = true;
                    if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                        this.currentPage = parseInt(localStorage.getItem('currentPage'));
                        this.active = (localStorage.getItem('active'));
                        this.getPage();


                    }
                    else {
                        if (this.isValid('CanDraftExpense') ) {
                            this.makeActive("Draft");
                        }
                        else if (this.isValid('CanViewExpense')) {
                            this.makeActive("Approved");
                        }

                    } this.currency = localStorage.getItem('currency');
                }
            }

        },
        updated: function () {

            if (this.selected.length < this.dailyExpenseList.length) {
                this.selectAll = false;
            } else if (this.selected.length == this.dailyExpenseList.length) {
                if (this.selected.length == 0) {
                    this.selectAll = false;
                }
                else {
                    this.selectAll = true
                }
            }
        }
    }
</script>